import { useAppSelector, useTranslate } from 'hooks';

import { selectUser } from 'selectors';

import { SettingsDisabledInput } from './SettingsDisabledInput';
import { SettingsCard } from './SettingsCard';

import s from './index.module.scss';

export const SettingsBankAccountCards = () => {
	const t = useTranslate(['bankAccountText', 'bankAccountsText']);
	const user = useAppSelector(selectUser);

	return (
		<SettingsCard title={t.bankAccountsText}>
			<div>
				{user.accounts.map((item) => {
					return (
						<div key={item.id} className={s.rateRow}>
							<SettingsDisabledInput
								className={s.col}
								name={t.bankAccountText}
								value={item.account}
							/>
						</div>
					);
				})}
			</div>
		</SettingsCard>
	);
};
